import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=2e1e839e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1e839e"]])

export default __exports__